module.exports = __webpack_public_path__ + "static/img/ML02.442e847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML02.jpg
// module id = quzk
// module chunks = 9